import PaymentProcessorContainer from './PaymentProcessorContainer';

export default PaymentProcessorContainer;
